import { ArrowLeft, ChevronRight, Calculator } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface DrawdownCreateHeaderProps {
  fundName: string;
  backTo: string;
  breadcrumbs: BreadcrumbItem[];
}

export function DrawdownCreateHeader({
  fundName,
  backTo,
  breadcrumbs,
}: DrawdownCreateHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="space-y-2">
      <nav className="flex items-center gap-1 text-sm text-muted-foreground">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate(backTo)}
          className="h-5 w-5 p-0 text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
        </Button>
        {breadcrumbs.map((crumb, index) => (
          <span key={crumb.label} className="flex items-center gap-1">
            {index > 0 && <ChevronRight className="h-3.5 w-3.5" />}
            {crumb.href ? (
              <Button
                variant="ghost"
                size="sm"
                onClick={() => navigate(crumb.href!)}
                className="h-auto p-0 text-muted-foreground hover:text-foreground"
              >
                {crumb.label}
              </Button>
            ) : (
              <span>{crumb.label}</span>
            )}
          </span>
        ))}
      </nav>

      <div className="flex items-center gap-3">
        <Calculator className="h-6 w-6 text-muted-foreground" />
        <div>
          <h1 className="text-2xl font-bold text-foreground">
            New Capital Call
          </h1>
          <p className="text-sm text-muted-foreground">{fundName}</p>
        </div>
      </div>
    </div>
  );
}
